// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3xR10","loaderOuter":"PageOverlayLoader_loaderOuter__1mIlV"};